module.exports = "<div *ngIf=\"!messageError\">\n  <div *ngIf=\"session\">\n    <app-publisher [session]=\"session\"></app-publisher>\n    <app-subscriber *ngFor=\"let stream of streams\" [stream]=\"stream\" [session]=\"session\"></app-subscriber>\n  </div>\n</div>\n\n<div *ngIf=\"messageError\">\n  <app-popin [titre]=\"TITRE_POPIN\" [messageError]=\"messageError\" [path]=\"PAGE_DOSSIER\"></app-popin>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/visio/visio.component.html
// module id = ./src/app/visio/visio.component.html
// module chunks = main